// libs
import styled from 'styled-components'
// components
import Popover from '@mui/material/Popover'
import { Button } from 'components/UI'
// themes
import colors from 'themes/colors'
// utils
import { darken } from 'polished'

export const StyledPopover = styled(Popover)`
  .MuiPopover-paper {
    border-radius: 8px;
    box-shadow:
      0 8px 24px rgba(0, 0, 0, 0.14),
      0 0 0 1px rgba(0, 0, 0, 0.05);
    margin-top: 6px;
  }
`

export const Form = styled.form<{ $width: number }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 14px;
  width: ${({ $width }) => $width}px;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
`

export const Footer = styled.div`
  display: flex;
  margin-top: 16px;
`

export const SaveButton = styled(Button)`
  && {
    button {
      border-radius: 16px;
      box-shadow: none;
      font-size: 13px;
      font-weight: 500;
      height: 32px;
      min-width: 0;
      padding: 0 14px;
      text-transform: none;

      &:not(:disabled):hover {
        background-color: ${darken(0.1, colors.purple300)} !important;
        border-color: ${darken(0.1, colors.purple300)};
      }
    }
  }
`
